var map = {
	"./status-amnesia.png": 4578,
	"./status-attack.png": 1846,
	"./status-defense.png": 1782,
	"./status-deprave.png": 1314,
	"./status-fire.png": 2304,
	"./status-hit.png": 352,
	"./status-ice.png": 9654,
	"./status-intelligence.png": 7667,
	"./status-paralyze.png": 8017,
	"./status-poison.png": 5762,
	"./status-resistance.png": 2306,
	"./status-sleep.png": 2499,
	"./status-speed.png": 4673,
	"./status-star.png": 932,
	"./status-wind.png": 2809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4295;